import EventEmitter from 'tiny-emitter'

import store from '../../store'

import { Emitter } from '../../events'

export default class Sizes extends EventEmitter {
  constructor() {
    super()

    this.width = store.bounds.ww
    this.height = store.bounds.wh
    
    this.pixelRatio = Math.min(window.devicePixelRatio, 2)

    this.addEvents()
  }

  addEvents() {
    Emitter.on('resize', () => {
      this.width = window.innerWidth
      this.height = window.innerHeight
      this.pixelRatio = Math.min(window.devicePixelRatio, 2)

      this.emit('resize')
    })
  }
}